import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
function RouteManagerLogoIcon(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      "data-testid": "routeManagerLogo",
      titleAccess: "RouteManager Logo",
      viewBox: "0 0 100 100",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50Z", fill: "#002D5C" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m48.646 22.436-2.936 4.15a2.897 2.897 0 0 1-2.372 1.226l-2.595-.005c-.93 0-1.798.454-2.32 1.224l-13.5 19.816a2.907 2.907 0 0 0-.083 3.143l10.466 17.237c1.034 1.705 3.468 1.814 4.652.207l15.133-20.55-2.574-1.448 12.808-5.613.858 13.314-2.523-1.42-20.875 29.857a2.8 2.8 0 0 1-2.28 1.195l-5.82.036a2.81 2.81 0 0 1-2.413-1.35l-19.17-31.553a2.796 2.796 0 0 1 .052-2.993l19.449-29.63a2.8 2.8 0 0 1 2.341-1.267l11.412.005c2.28 0 3.603 2.564 2.29 4.42Z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m51.375 77.078 2.956-4.15a2.903 2.903 0 0 1 2.367-1.22l2.559.005c.93 0 1.799-.455 2.32-1.225l13.5-19.81c.642-.942.673-2.167.083-3.143L64.694 30.298c-1.034-1.706-3.468-1.814-4.652-.207L44.91 50.641l2.574 1.447-12.807 5.613-.858-13.314 2.522 1.421L57.215 15.95a2.8 2.8 0 0 1 2.28-1.194l5.82-.036a2.81 2.81 0 0 1 2.413 1.349l19.17 31.553a2.796 2.796 0 0 1-.052 2.993L67.397 80.246a2.8 2.8 0 0 1-2.341 1.266l-11.397-.005c-2.279-.005-3.602-2.579-2.284-4.43Z",
            fill: "#fff"
          }
        )
      ]
    }
  );
}
export {
  RouteManagerLogoIcon
};
//# sourceMappingURL=RouteManagerLogoIcon.js.map
